import React from 'react';

const achievements = [
  { platform: 'LeetCode', title: '365 Days', detail: '365+ submission days in total', image: '/badges/leetcode-365.webp', link: 'https://leetcode.com/medal/?showImg=0&id=10678676&isLevel=false' },
  { platform: 'LeetCode', title: '50 Days · 2025', detail: 'Coding consistency', image: '/badges/leetcode-50-2025.webp', link: 'https://leetcode.com/medal/?showImg=0&id=7343279&isLevel=false' },
  { platform: 'LeetCode', title: '100 Days · 2024', detail: 'Coding consistency', image: '/badges/leetcode-100-2024.webp', link: 'https://leetcode.com/medal/?showImg=0&id=3792928&isLevel=false' },
  { platform: 'LeetCode', title: 'SQL 50', detail: 'SQL study plan', image: '/badges/leetcode-sql-50.webp', link: 'https://leetcode.com/medal/?showImg=0&id=3904114&isLevel=false' },
  { platform: 'LeetCode', title: 'Pandas', detail: 'Pandas study plan', image: '/badges/leetcode-pandas.webp', link: 'https://leetcode.com/medal/?showImg=0&id=3297587&isLevel=false' },
  { platform: 'GitHub', title: 'Pull Shark', detail: 'Pull request collaboration', image: '/badges/github-pull-shark.webp', link: 'https://github.com/users/mhdnihas/achievements/pull-shark' },
  { platform: 'GitHub', title: 'YOLO', detail: 'GitHub achievement', image: '/badges/github-yolo.webp', link: 'https://github.com/users/mhdnihas/achievements/yolo' },
];

const Achievements = () => (
  <details className="recognition-details">
    <summary className="recognition-summary">
      <span className="recognition-summary-copy">
        <span className="recognition-summary-title">Additional platform recognition</span>
        <span className="recognition-summary-meta">7 badges from LeetCode and GitHub</span>
      </span>
      <span className="recognition-summary-action" aria-hidden="true">
        <span className="recognition-show-label">View badges</span>
        <span className="recognition-hide-label">Hide badges</span>
        <span className="recognition-summary-arrow">⌄</span>
      </span>
    </summary>
    <div className="recognition-content">
      <p className="recognition-note">Select a badge to view it on the original platform.</p>
      <div className="recognition-grid">
        {achievements.map((item) => (
          <a
            className={`recognition-card${item.platform === 'GitHub' ? ' is-github' : ''}`}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            key={`${item.platform}-${item.title}`}
          >
            <div className="recognition-card-top"><span className="mono">{item.platform}</span><span aria-hidden="true">↗</span></div>
            <div className="recognition-card-body">
              <div className="recognition-card-art"><img src={item.image} alt="" width="112" height="112" loading="lazy" /></div>
              <div className="recognition-card-copy"><h4>{item.title}</h4><p>{item.detail}</p></div>
            </div>
            <span className="recognition-card-action">View badge <span aria-hidden="true">→</span></span>
          </a>
        ))}
      </div>
    </div>
  </details>
);

export default Achievements;
